import {
  CDBTable,
  CDBTableHeader,
  CDBTableBody
} from "cdbreact";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import PaginationBootstrap from "../../../../components/PaginationBootstrap";
const dayjs = require("dayjs");

const VendasPagasTable = (props) => {
  return (
    <>
      <>
        <CDBTable className="alcon-table" responsiveSm borderless>
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Veículo</th>
              <th>Cliente</th>
              <th>Pagamento</th>
              <th>Total</th>
              <th className="text-end px-4">Ações</th>
            </tr>
          </thead>
          <tbody>
            {props.sales && props.sales.map((sale) => (
              <tr key={sale.id}>
                {/* Data da Baixa (paidAt) */}
                <td className="text-muted small">
                  <div className="fw-bold text-dark">{dayjs(sale.createAt).format("DD/MM/YYYY")}</div>
                  <div className="opacity-75">{dayjs(sale.createdAt).format("HH:mm")}</div>
                </td>

                {/* Informação do Veículo */}
                <td className="fw-bold text-dark align-middle">
                  {sale.vehicleInfo}
                </td>

                {/* Cliente com fallback */}
                <td className="text-muted align-middle">
                  <i className="fas fa-user-circle me-1 small"></i>
                  {sale.customer ? sale.customer.name : "Não identificado"}
                </td>

                {/* Forma de Pagamento com Badge Cinza */}
                <td className="align-middle">
                  <span className="badge bg-light text-dark border fw-medium px-2 py-1" style={{ fontSize: '0.7rem' }}>
                    <i className="fas fa-wallet me-1 text-secondary"></i>
                    {sale.paymentMethod}
                  </span>
                </td>

                {/* Total Líquido (Verde Sucesso) */}
                <td className="fw-bold text-success align-middle" style={{ fontSize: '1rem' }}>
                  {currencyBRFormat(
                    parseFloat(sale.total) + (sale.adtionalValue || 0) - (sale.discount || 0)
                  )}
                </td>

                {/* Ações usando seu novo padrão .btn-3-dots */}
                <td className="text-end align-middle px-3">
                  <div className="dropdown">
                    <button
                      className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-display="static"
                    >
                      <i className="fas fa-ellipsis-v"></i>
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                      <li>
                        <button className="dropdown-item py-2 d-flex align-items-center" onClick={() => props.handleCorrigirVenda(sale)}>
                          <i className="fas fa-edit me-2 text-primary"></i> Corrigir Venda
                        </button>
                      </li>
                      <div className="d-none TODO FEATURE FUTURA">
                      <li><hr className="dropdown-divider" /></li>
                      <li>
                        <button className="dropdown-item py-2 d-flex align-items-center" onClick={() => props.handleRecibo(sale)}>
                          <i className="fas fa-file-invoice-dollar me-2 text-secondary"></i> Ver Recibo
                        </button>
                      </li>
                      <li>
                        <button className="dropdown-item py-2 d-flex align-items-center" onClick={() => props.handleReenviar(sale)}>
                          <i className="fas fa-share-square me-2 text-success"></i> Reenviar Recibo
                        </button>
                      </li>
                      </div>
                    </ul>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </CDBTable>
      </>
      <PaginationBootstrap
        pageInfo={props.pageInfo}
        goToPage={props.goToPage}
      />
    </>
  );
};

export default VendasPagasTable;
